import MainData from '../main'
import axios from 'axios'

const isLoadingDisabled = (config={}) => {
  return config.hasOwnProperty('loadingDisabled') && !config.loadingDisabled ?
    false : true
}

// Axios request interceptor
axios.interceptors.request.use(
  function (config) {
    if (!isLoadingDisabled(config)) {
      MainData.store.commit('validateLoading', true)
    }
    return config
  },
  function (error) {
    MainData.store.commit('validateLoading', false)
    return Promise.reject(error)
  }
)

// Axios response interceptor
axios.interceptors.response.use(
  function (config) {
    MainData.store.commit('validateLoading', false)
    return config
  },
  function (error) {
    MainData.store.commit('validateLoading', false)
    return Promise.reject(error)
  }
)
